<script lang="ts">
	import { onMount } from "svelte"

	interface Props {
		loadingText: string;
	}

	let { loadingText }: Props = $props();

	let ellipsis = $state("")
	let ellipsisIndex = 0

	function initText() {
		ellipsis = ""
		setInterval(() => {
			if (ellipsisIndex > 3) ellipsisIndex = 0
			ellipsis = `${".".repeat(ellipsisIndex)}`
			ellipsisIndex++
		}, 750)
	}

	onMount(() => {
		if (loadingText) initText()
	})
</script>

<span class="loader"></span>
<br />
<span class="loading-text"
	>{loadingText}
	<span class="ellipsis">
		{ellipsis}
	</span>
</span>

<style>
	:global(html) {
		--loader-border-color: var(--color-main);
		--loader-color: var(--color-main);
		--loader-width: 2rem;
	}

	.loading-text {
		color: var(--color-text);
	}

	.loader {
		width: var(--loader-width);
		height: var(--loader-width);
		border-radius: 50%;
		display: inline-block;
		position: relative;
		border: 0.5rem solid;
		border-color: var(--loader-border-color) var(--loader-border-color) transparent;
		box-sizing: border-box;
		animation: rotation 2s linear infinite;
	}

	.loader::after {
		content: "";
		box-sizing: border-box;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		border: 0.5rem solid;
		border-color: transparent var(--loader-color) var(--loader-color);
		width: calc(var(--loader-width) / 2);
		height: calc(var(--loader-width) / 2);
		border-radius: 50%;
		animation: rotationBack 1s linear infinite;
		transform-origin: center center;
	}

	.ellipsis {
		position: absolute;
	}

	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes rotationBack {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(-360deg);
		}
	}
</style>
